import { loc } from "../../../../core/utils"
import TextField from "../../../../form/TextField"
import React from "react"
import { Button } from "react-bootstrap"

function PromotionCodeVerifier({ verifyPromotionCode }) {
  return (
    <section className="d-flex align-items-center" style={{ gap: "2rem" }}>
      <label style={{ margin: 0 }}>{loc("simulation_promotion_input_label")}</label>
      <TextField name="promoCode" style={{ margin: 0 }} />
      <Button type="button" variant="outline-primary" style={{ width: "auto" }} onClick={verifyPromotionCode}>
        {loc("simulation_promotion_button_label")}
      </Button>
    </section>
  )
}

export default PromotionCodeVerifier
